import { useRef, useEffect, useState } from 'react';

function ScrollReveal({ children, className, delay }) {
  var ref = useRef(null);
  var [visible, setVisible] = useState(false);

  useEffect(function () {
    var el = ref.current;
    if (!el) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(el);
    return function () { observer.disconnect(); };
  }, []);

  var style = {
    transitionDelay: (delay || 0) + 'ms',
  };

  return (
    <div
      ref={ref}
      className={'scroll-reveal' + (visible ? ' scroll-reveal--visible' : '') + (className ? ' ' + className : '')}
      style={style}
    >
      {children}
    </div>
  );
}

export default ScrollReveal;
